/* Ar Rihla theme - vanilla JS, no dependencies */
(function () {
  'use strict';
  var R = (window.ArRihla && window.ArRihla.routes) || { cart_add: '/cart/add.js', cart_change: '/cart/change.js', cart: '/cart' };
  var $ = function (s, el) { return (el || document).querySelector(s); };
  var $$ = function (s, el) { return Array.prototype.slice.call((el || document).querySelectorAll(s)); };
  var store = {
    get: function (k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  };

  /* Announcement rotation */
  var ann = $('[data-announcement]');
  if (ann) {
    var items = $$('.announcement__item', ann);
    if (items.length > 1) {
      var i = 0;
      setInterval(function () {
        items[i].classList.remove('is-active');
        i = (i + 1) % items.length;
        items[i].classList.add('is-active');
      }, 4000);
    }
  }

  /* Drawers */
  var overlay = $('[data-overlay]');
  var lastFocus = null;
  function openDrawer(name) {
    var d = $('[data-drawer="' + name + '"]');
    if (!d) return false;
    closeAll();
    lastFocus = document.activeElement;
    d.classList.add('is-open');
    if (overlay) overlay.hidden = false;
    document.body.classList.add('no-scroll');
    var f = d.querySelector('button, a, input, select');
    if (f) setTimeout(function () { f.focus(); }, 50);
    return true;
  }
  function closeAll() {
    $$('.drawer.is-open, .sheet.is-open').forEach(function (d) { d.classList.remove('is-open'); });
    if (overlay) overlay.hidden = true;
    document.body.classList.remove('no-scroll');
  }
  function closeDrawers() {
    closeAll();
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-open]');
    if (opener) {
      if (openDrawer(opener.getAttribute('data-open'))) e.preventDefault();
      return;
    }
    if (e.target.closest('[data-close]') || e.target === overlay) closeDrawers();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawers(); });

  /* Toast */
  function toast(msg) {
    var t = document.createElement('div');
    t.className = 'toast'; t.setAttribute('role', 'status'); t.textContent = msg;
    document.body.appendChild(t);
    setTimeout(function () { t.remove(); }, 2600);
  }

  /* Cart */
  function cartPageSectionId() {
    var page = $('[data-cart-page]');
    if (!page) return null;
    var sec = page.closest('.shopify-section');
    return sec ? sec.id.replace('shopify-section-', '') : null;
  }
  function sectionsParam() {
    var s = ['cart-drawer'];
    var pid = cartPageSectionId();
    if (pid) s.push(pid);
    return s;
  }
  function applySections(sections) {
    if (!sections) return;
    var html = sections['cart-drawer'];
    if (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var inner = doc.querySelector('[data-cart-inner]');
      var cur = $('[data-cart-inner]');
      if (inner && cur) cur.innerHTML = inner.innerHTML;
      var cnt = doc.querySelector('[data-cart-count-src]');
      if (cnt) updateCount(parseInt(cnt.textContent, 10) || 0);
    }
    var pid = cartPageSectionId();
    if (pid && sections[pid]) {
      var d2 = new DOMParser().parseFromString(sections[pid], 'text/html');
      var pi = d2.querySelector('[data-cart-page-inner]');
      var target = $('[data-cart-page-inner]');
      if (pi && target) target.innerHTML = pi.innerHTML;
    }
  }
  function updateCount(n) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = n > 0 ? n : ''; el.setAttribute('data-count', n); });
    $$('[data-cart-link]').forEach(function (el) { el.setAttribute('aria-label', 'Cart, ' + n + ' items'); });
  }
  function addToCart(items, btn) {
    if (btn) btn.classList.add('is-loading');
    return fetch(R.cart_add, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items, sections: sectionsParam(), sections_url: window.location.pathname })
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
      .then(function (res) {
        if (btn) btn.classList.remove('is-loading');
        if (!res.ok) { toast(res.json.description || res.json.message || 'Could not add to cart'); return; }
        applySections(res.json.sections);
        if (!$('[data-cart-page]')) openDrawer('cart');
      })
      .catch(function () { if (btn) btn.classList.remove('is-loading'); toast('Something went wrong. Please try again.'); });
  }
  function changeLine(line, qty) {
    return fetch(R.cart_change, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty, sections: sectionsParam(), sections_url: window.location.pathname })
    }).then(function (r) { return r.json(); }).then(function (j) { applySections(j.sections); });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-line-change]');
    if (!b) return;
    e.preventDefault();
    changeLine(parseInt(b.getAttribute('data-line-change'), 10), Math.max(0, parseInt(b.getAttribute('data-qty'), 10)));
  });
  document.addEventListener('submit', function (e) {
    var f = e.target.closest('[data-ajax-add]');
    if (!f) return;
    e.preventDefault();
    var id = f.querySelector('[name="id"]').value;
    addToCart([{ id: parseInt(id, 10), quantity: 1 }], f.querySelector('button'));
  });

  /* Size finder (height -> size) */
  function savedSize() { return store.get('arh_size'); }
  var grid = $('[data-grid]');
  var activeSize = 'all';
  $$('[data-size-finder]').forEach(function (box) {
    var sel = $('[data-height-select]', box);
    var out = $('[data-size-result]', box);
    var shop = $('[data-size-shop]', box);
    var apply = $('[data-size-apply]', box);
    var target = box.getAttribute('data-target');
    var saved = store.get('arh_height');
    if (saved && sel) { var o = sel.options[parseInt(saved, 10)]; if (o) sel.selectedIndex = parseInt(saved, 10); }
    function update() {
      var size = sel.value;
      if (out) out.textContent = 'Size ' + size;
      if (shop) { shop.textContent = 'Shop size ' + size; shop.href = target + '?size=' + size; }
      if (apply) apply.textContent = (box.hasAttribute('data-pick-variant') ? 'Select size ' : 'Show size ') + size;
    }
    if (sel) sel.addEventListener('change', function () {
      store.set('arh_size', sel.value); store.set('arh_height', String(sel.selectedIndex)); update();
    });
    if (apply) apply.addEventListener('click', function () {
      store.set('arh_size', sel.value); store.set('arh_height', String(sel.selectedIndex));
      if (box.hasAttribute('data-pick-variant')) {
        var input = document.querySelector('[data-variant][data-label="' + sel.value + '"]');
        if (input && !input.disabled) { input.checked = true; input.dispatchEvent(new Event('change', { bubbles: true })); input.closest('.sizes').scrollIntoView({ behavior: 'smooth', block: 'center' }); }
        else toast('Size ' + sel.value + ' is not available in this colour.');
      } else {
        setSizeFilter(sel.value);
        var bar = $('[data-filterbar]'); if (bar) bar.scrollIntoView({ behavior: 'smooth' });
      }
    });
    if (sel) update();
  });

  /* Collection: size filter + quick add */
  function cardVariants(card) {
    var s = card.querySelector('[data-variants]');
    try { return JSON.parse(s.textContent); } catch (e) { return []; }
  }
  function setSizeFilter(size) {
    activeSize = size;
    $$('[data-size-chip]').forEach(function (c) { c.setAttribute('aria-pressed', c.getAttribute('data-size-chip') === size ? 'true' : 'false'); });
    if (!grid) return;
    var cards = $$('[data-card]', grid);
    var shown = 0, inStock = [], pre = [], none = [];
    cards.forEach(function (card) {
      var btn = card.querySelector('[data-quick-add]');
      var vs = cardVariants(card);
      if (size === 'all') {
        card.hidden = false; card.classList.remove('is-dim'); shown++;
        if (btn) btn.textContent = 'Quick add';
        inStock.push(card); return;
      }
      var m = vs.filter(function (v) { return v.size === size; })[0];
      if (!m || m.status === 'out') { card.hidden = true; none.push(card); return; }
      card.hidden = false; shown++;
      if (m.status === 'pre') { card.classList.add('is-dim'); if (btn) btn.textContent = 'Pre-order ' + size; pre.push(card); }
      else { card.classList.remove('is-dim'); if (btn) btn.textContent = 'Add size ' + size; inStock.push(card); }
    });
    inStock.concat(pre, none).forEach(function (c) { grid.appendChild(c); });
    var count = $('[data-count]');
    if (count) count.textContent = size === 'all' ? cards.length + ' items' : inStock.length + ' in stock in ' + size + (pre.length ? ' · ' + pre.length + ' pre-order' : '');
    var empty = $('[data-empty]'); if (empty) empty.hidden = shown > 0;
    var url = new URL(window.location.href);
    if (size === 'all') url.searchParams.delete('size'); else url.searchParams.set('size', size);
    history.replaceState(null, '', url.toString());
  }
  $$('[data-size-chip]').forEach(function (c) {
    c.addEventListener('click', function () {
      var s = c.getAttribute('data-size-chip');
      setSizeFilter(s);
      if (s !== 'all') store.set('arh_size', s);
    });
  });
  if (grid) {
    var p = new URL(window.location.href).searchParams.get('size');
    if (p && $('[data-size-chip="' + p + '"]')) setSizeFilter(p);
  }
  var sort = $('[data-sort]');
  if (sort) sort.addEventListener('change', function () {
    var url = new URL(window.location.href); url.searchParams.set('sort_by', sort.value); window.location.href = url.toString();
  });

  /* Quick add sheet */
  var sheet = null;
  function ensureSheet() {
    if (sheet) return sheet;
    sheet = document.createElement('div');
    sheet.className = 'sheet'; sheet.setAttribute('role', 'dialog'); sheet.setAttribute('aria-modal', 'true'); sheet.setAttribute('aria-label', 'Choose a size');
    sheet.innerHTML = '<div class="sheet__head"><h2 class="sheet__title"></h2><button type="button" class="icon-btn" data-close aria-label="Close"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button></div><p class="muted" style="font-size:13px;margin-bottom:12px">Choose your size</p><div class="size-grid"></div><a class="btn btn--outline btn--block" style="margin-top:12px" data-sheet-link>Not sure? View details &amp; size guide</a>';
    document.body.appendChild(sheet);
    return sheet;
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-quick-add]');
    if (!b) return;
    var card = b.closest('[data-card]');
    var vs = cardVariants(card).filter(function (v) { return v.status !== 'out'; });
    if (!vs.length) return;
    if (vs.length === 1) { addToCart([{ id: vs[0].id, quantity: 1 }], b); return; }
    if (activeSize !== 'all') {
      var m = vs.filter(function (v) { return v.size === activeSize; })[0];
      if (m) { addToCart([{ id: m.id, quantity: 1 }], b); return; }
    }
    var s = ensureSheet();
    $('.sheet__title', s).textContent = b.getAttribute('data-title');
    $('[data-sheet-link]', s).href = card.getAttribute('data-product-url');
    var g = $('.size-grid', s); g.innerHTML = '';
    var pref = savedSize();
    vs.forEach(function (v) {
      var btn = document.createElement('button');
      btn.type = 'button'; btn.className = 'size-btn';
      var note = v.status === 'pre' ? 'Pre-order' : (v.status === 'low' ? 'Low stock' : 'In stock');
      btn.innerHTML = '<b></b><small></small>';
      btn.querySelector('b').textContent = v.size; btn.querySelector('small').textContent = note;
      if (pref && v.size === pref) { btn.style.borderColor = 'var(--gold)'; }
      btn.addEventListener('click', function () { closeAll(); addToCart([{ id: v.id, quantity: 1 }], b); });
      g.appendChild(btn);
    });
    closeAll(); lastFocus = b;
    s.classList.add('is-open'); if (overlay) overlay.hidden = false; document.body.classList.add('no-scroll');
    var first = g.querySelector('button'); if (first) setTimeout(function () { first.focus(); }, 50);
  });

  /* Product page */
  var form = $('[data-product-form]');
  if (form) {
    var atc = $('[data-atc]', form);
    var msg = $('[data-stock-msg]');
    var nameEl = $('[data-size-name]');
    var priceNow = $('[data-price-now]'), priceWas = $('[data-price-was]'), priceSave = $('[data-price-save]');
    var sticky = $('[data-sticky-atc]'), stickyPrice = $('[data-sticky-price]'), stickyName = $('[data-sticky-name]'), stickyBtn = $('[data-sticky-btn]');
    var baseTitle = stickyName ? stickyName.textContent : '';
    function selected() { return form.querySelector('[data-variant]:checked'); }
    function render() {
      var v = selected();
      if (!v) { if (msg) msg.textContent = ''; return; }
      var st = v.getAttribute('data-status'), lb = v.getAttribute('data-label'), price = v.getAttribute('data-price');
      if (nameEl) nameEl.textContent = lb + (st === 'pre' ? ' (pre-order)' : '');
      if (priceNow) priceNow.textContent = price;
      var cmp = v.getAttribute('data-compare');
      if (priceWas) { priceWas.hidden = !cmp; priceWas.textContent = cmp; }
      if (priceSave) { var sv = v.getAttribute('data-save'); priceSave.hidden = !sv; priceSave.textContent = sv ? 'Save ' + sv + '%' : ''; }
      var label = 'Add to cart — ' + price;
      if (msg) {
        msg.className = 'stock-msg';
        if (st === 'pre') { label = 'Pre-order — ' + price; msg.textContent = v.getAttribute('data-pre-msg') || 'Pre-order: ships by mid-January. Reserve yours now.'; msg.classList.add('is-warn'); }
        else if (st === 'low') { msg.textContent = 'Only ' + v.getAttribute('data-qty') + ' left in this size.'; msg.classList.add('is-warn'); }
        else { msg.textContent = 'In stock — ships in 1–2 business days.'; }
      }
      if (atc) { atc.textContent = label; atc.disabled = false; }
      if (stickyPrice) stickyPrice.textContent = price;
      if (stickyName) stickyName.textContent = baseTitle + ' · ' + lb;
      if (stickyBtn) stickyBtn.textContent = st === 'pre' ? 'Pre-order' : 'Add to cart';
      var url = new URL(window.location.href); url.searchParams.set('variant', v.value); history.replaceState(null, '', url.toString());
    }
    form.addEventListener('change', function (e) { if (e.target.matches('[data-variant]')) render(); });
    var hasParam = new URL(window.location.href).searchParams.get('variant');
    var pref = savedSize();
    if (!hasParam && pref) {
      var match = form.querySelector('[data-variant][data-label="' + pref + '"]');
      if (match && !match.disabled) match.checked = true;
    }
    render();
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var id = form.querySelector('[name="id"]:checked') || form.querySelector('input[type="hidden"][name="id"]');
      if (!id) { toast('Please choose a size'); return; }
      var v = selected(); if (v) store.set('arh_size', v.getAttribute('data-label'));
      addToCart([{ id: parseInt(id.value, 10), quantity: 1 }], atc);
    });
    if (sticky && atc && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var vis = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', vis);
        sticky.setAttribute('aria-hidden', vis ? 'false' : 'true');
        if (stickyBtn) stickyBtn.tabIndex = vis ? 0 : -1;
      }).observe(atc);
    }
    if (stickyBtn) stickyBtn.addEventListener('click', function () { if (form.requestSubmit) form.requestSubmit(); else atc.click(); });
    $$('[data-open-size]').forEach(function (a) {
      a.addEventListener('click', function (e) { var d = $('#SizeGuide'); if (d) { e.preventDefault(); d.open = true; d.scrollIntoView({ behavior: 'smooth', block: 'start' }); } });
    });
  }

  /* Gallery counter */
  var track = $('[data-gallery]'), counter = $('[data-gallery-count]');
  if (track && counter) {
    var total = track.children.length;
    track.addEventListener('scroll', function () {
      var idx = Math.round(track.scrollLeft / track.clientWidth) + 1;
      counter.textContent = Math.min(idx, total) + ' / ' + total;
    }, { passive: true });
  }
})();
